var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcFood = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_50",
  "data-name": "Path 50",
  d: "M0-24H48V24H0Z",
  transform: "translate(0 24)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_52",
  "data-name": "Path 52",
  d: "M6-22H34.006a2,2,0,0,1,2,2V16a2,2,0,0,1-2,2H6a2,2,0,0,1-2-2V-20A2,2,0,0,1,6-22Z",
  transform: "translate(-4 22)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-3"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_56",
  "data-name": "Path 56",
  d: "M7-12v2H27v-2Z",
  transform: "translate(-7 12)",
  fill: "#fc6312",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-5"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_58",
  "data-name": "Path 58",
  d: "M7-15v2h8v-2Z",
  transform: "translate(-7 15)",
  fill: "#fc6312",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-7"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_64",
  "data-name": "Path 64",
  d: "M18.309-11.567a1.008,1.008,0,0,0-.416-.816,4.043,4.043,0,0,0-1.4-.6,4.843,4.843,0,0,1-2-.892,1.776,1.776,0,0,1-.628-1.4,1.818,1.818,0,0,1,.616-1.416,2.88,2.88,0,0,1,1.692-.658V-18.5h.96v1.158a2.676,2.676,0,0,1,1.686.742,2.338,2.338,0,0,1,.6,1.7H18.231a1.6,1.6,0,0,0-.432-1.179,1.566,1.566,0,0,0-1.167-.437,1.846,1.846,0,0,0-1.173.324,1.09,1.09,0,0,0-.406.9,1.012,1.012,0,0,0,.429.855,4.33,4.33,0,0,0,1.412.579,6.619,6.619,0,0,1,1.534.574,2.229,2.229,0,0,1,.812.729,1.793,1.793,0,0,1,.261.974,1.768,1.768,0,0,1-.654,1.432,3.244,3.244,0,0,1-1.834.642V-8.5h-.954V-9.5a3.079,3.079,0,0,1-1.879-.7,2.1,2.1,0,0,1-.68-1.65h1.192a1.388,1.388,0,0,0,.471,1.127,2.02,2.02,0,0,0,1.334.395,2.319,2.319,0,0,0,1.328-.332A1.042,1.042,0,0,0,18.309-11.567Z",
  transform: "translate(-13.5 18.5)",
  fill: "none",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path-8"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_962",
  "data-name": "Rectangle 962",
  width: 18,
  height: 10,
  transform: "translate(15 6)",
  fill: "#fff"
})))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "ic_food",
  transform: "translate(0 24)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_92",
  "data-name": "Group 92",
  transform: "translate(0 -24)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_49",
  "data-name": "Path 49",
  d: "M-5-29H63V39H-5Z",
  transform: "translate(-5 19)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_94",
  "data-name": "Group 94",
  transform: "translate(7.997 -19.999)",
  clipPath: "url(#clip-path-2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_93",
  "data-name": "Group 93"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_51",
  "data-name": "Path 51",
  d: "M2,0H30.006a2,2,0,0,1,2,2V38a2,2,0,0,1-2,2H2a2,2,0,0,1-2-2V2A2,2,0,0,1,2,0Z",
  fill: "none",
  stroke: "#fc6312",
  strokeWidth: 2
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_96",
  "data-name": "Group 96",
  transform: "translate(13.998 10)",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_55",
  "data-name": "Path 55",
  d: "M2-17H42.007V5H2Z",
  transform: "translate(-12.002 6.998)",
  fill: "#fc6312"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1259",
  "data-name": "Group 1259",
  transform: "translate(13.998 14.999)",
  clipPath: "url(#clip-path-3)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_437",
  "data-name": "Path 437",
  d: "M2-17H42.007V5H2Z",
  transform: "translate(-12.002 6.998)",
  fill: "#fc6312"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_97",
  "data-name": "Group 97",
  transform: "translate(13.999 5)",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_57",
  "data-name": "Path 57",
  d: "M2-20H30.005V2H2Z",
  transform: "translate(-12.002 9.998)",
  fill: "#fc6312"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1268",
  "data-name": "Group 1268",
  transform: "translate(13.999 0.001)",
  clipPath: "url(#clip-path-5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_441",
  "data-name": "Path 441",
  d: "M2-20H30.005V2H2Z",
  transform: "translate(-12.002 9.998)",
  fill: "#fc6312"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_100",
  "data-name": "Group 100",
  transform: "translate(26.999 -2.001)",
  clipPath: "url(#clip-path-7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_63",
  "data-name": "Path 63",
  d: "M8.5-23.5h26V6.506H8.5Z",
  transform: "translate(-18.502 13.498)",
  fill: "#fc6312"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_101",
  "data-name": "Group 101",
  transform: "translate(26.999 -2.001)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_65",
  "data-name": "Path 65",
  d: "M4.809,6.933a1.008,1.008,0,0,0-.416-.816,4.042,4.042,0,0,0-1.4-.6,4.844,4.844,0,0,1-2-.892,1.776,1.776,0,0,1-.628-1.4A1.818,1.818,0,0,1,.977,1.811a2.88,2.88,0,0,1,1.692-.658V0h.96V1.158A2.676,2.676,0,0,1,5.315,1.9a2.338,2.338,0,0,1,.6,1.7H4.731A1.6,1.6,0,0,0,4.3,2.422a1.566,1.566,0,0,0-1.167-.437,1.846,1.846,0,0,0-1.173.324,1.09,1.09,0,0,0-.406.9,1.012,1.012,0,0,0,.429.855,4.331,4.331,0,0,0,1.412.579,6.62,6.62,0,0,1,1.534.574,2.229,2.229,0,0,1,.812.729A1.793,1.793,0,0,1,6,6.922a1.768,1.768,0,0,1-.654,1.432A3.243,3.243,0,0,1,3.513,9V10H2.559V9A3.079,3.079,0,0,1,.68,8.3,2.1,2.1,0,0,1,0,6.649H1.192a1.388,1.388,0,0,0,.471,1.127A2.02,2.02,0,0,0,3,8.17a2.319,2.319,0,0,0,1.328-.332A1.042,1.042,0,0,0,4.809,6.933Z",
  fill: "none",
  stroke: "#fc6312",
  strokeWidth: 0.3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_1257",
  "data-name": "Group 1257",
  transform: "translate(0 -20)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_39",
  "data-name": "Mask Group 39",
  clipPath: "url(#clip-path-8)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_106",
  "data-name": "Ellipse 106",
  transform: "translate(15 6)",
  fill: "none",
  stroke: "#fc6312",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 9,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 9,
  cy: 9,
  r: 8,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_963",
  "data-name": "Rectangle 963",
  transform: "translate(23 4)",
  fill: "#fff",
  stroke: "#fc6312",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 2,
  height: 3,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 1,
  height: 2,
  rx: 0.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "Rectangle_964",
  "data-name": "Rectangle 964",
  transform: "translate(13 14)",
  fill: "#fff",
  stroke: "#fc6312",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 2,
  rx: 1,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 21,
  height: 1,
  rx: 0.5,
  fill: "none"
}))))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcFood);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "matrices-static/media/ic_food.172edbd373e6478f40125b72097cf242.svg";